import React from 'react'
import style from "./style.module.css"
export const Instructions = ({ closePopup }) => {
    return (
        <div className={style.mainDiv}>
            <h2>Important Information</h2>
            <p>
                1. Please sit in a quite environment for exam. And please don't look here and there while exam is going on. Examiners are monitoring you throughout the exam.<br />
                2. Please make sure that you have strong internet connection, good visibility camera and good sensitivity mic. You will get only one chance to reconnect if you by mistakely lost your internet connection or refreshed the page.<br />
                3. Once the exam gets start you cannot leave the tab more than 5 times. Leaving tab 5th time will auto submit your paper.<br />
                4. Please follow teachers instructions if they says something. If you caught cheating examiner can ban you from exam.
            </p>
            <button onClick={() => closePopup()} className={style.understoodBtn}>I Understood</button>
        </div>
    )
}
